/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_4_ClientInputs */

const et_portfolio_project_4_client = /** @type {(inputs: Portfolio_Project_4_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundalini Kakao (Tseremoniaalne kakao)`)
};

const en_portfolio_project_4_client = /** @type {(inputs: Portfolio_Project_4_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundalini Kakao (Ceremonial cacao)`)
};

/**
* | output |
* | --- |
* | "Kundalini Kakao (Ceremonial cacao)" |
*
* @param {Portfolio_Project_4_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_4_client = /** @type {((inputs?: Portfolio_Project_4_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_4_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_4_client(inputs)
	return en_portfolio_project_4_client(inputs)
});